import { render, staticRenderFns } from "./PricesColumn.vue?vue&type=template&id=454d6aa7&scoped=true&"
import script from "./PricesColumn.vue?vue&type=script&lang=ts&"
export * from "./PricesColumn.vue?vue&type=script&lang=ts&"
import style0 from "./PricesColumn.vue?vue&type=style&index=0&id=454d6aa7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454d6aa7",
  null
  
)

export default component.exports